import { useState } from "react";

/**
 * BrandLogo
 * Renders a brand "lockup": real favicon (via Google's icon service) + brand name.
 * If the icon fails to load, falls back to a gold dot.
 * Layout adapts: when name is omitted, only the icon is shown.
 */
export const BrandLogo = ({
  name,
  domain,
  className = "",
  showName = true,
  size = 28,
  monochrome = false,
}) => {
  const [iconError, setIconError] = useState(false);
  const iconUrl = domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=128` : null;

  return (
    <div
      title={name}
      className={`group inline-flex items-center gap-3 px-2 ${className}`}
    >
      <span
        className="flex items-center justify-center flex-shrink-0"
        style={{ width: size, height: size }}
      >
        {iconUrl && !iconError ? (
          <img
            src={iconUrl}
            alt=""
            onError={() => setIconError(true)}
            className={`object-contain ${monochrome ? "grayscale group-hover:grayscale-0 transition-all duration-500" : ""}`}
            style={{ width: size, height: size }}
            loading="lazy"
          />
        ) : (
          <span className="block w-3 h-3 bg-[#B8860B] rounded-full" />
        )}
      </span>

      {showName && (
        <span className="font-display text-stone-800 text-base md:text-lg tracking-tight whitespace-nowrap group-hover:text-[#B8860B] transition-colors leading-none">
          {name}
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
